var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tag',{attrs:{"color":_vm.tagColor,"text":`${_vm.value || 0} %`,"icon-left":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }